import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
      MenuItem,
    Select,
    InputLabel,
  Typography, IconButton, Grid, Checkbox, FormControlLabel, Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Chip
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { fetchSuppliers } from '../service/supplierService';
import warehouseService from '../service/warehouseService'; 


const daysOfWeek = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

const WarehouseManager: React.FC = () => {
  const [warehouses, setWarehouses] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingWarehouse, setEditingWarehouse] = useState(
    null
  );

    const [suppliers, setSuppliers] = useState([]);
  // Form state
  const [form, setForm] = useState({
    name: "",
    address: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    supplierId: undefined,
    primary: 0,
    phone: "",
    email:"",
    schedules: [],
      holidays: []
  });
 

  useEffect(() => {
    fetchWarehouses();
      fetchAllSuppliers();
  }, []);

  const fetchWarehouses = async () => {
    const res = await warehouseService.fetchSupplierWarehouse();
    setWarehouses(res);
  };
    
       
      const fetchAllSuppliers = async () => {
    const res = await fetchSuppliers();
    setSuppliers(res.data);
  };
    
      const handleSupplierChange = (e) => {
    // The value from the Select component is the supplierId.
    const selectedSupplierId = e.target.value;

    // Update the state with the selected supplier's ID.
    setForm({
      ...form,
      supplierId: selectedSupplierId,
    });
  };
  const [schedules, setSchedules] = useState(defaultSchedules());
  const [holidays, setHolidays] = useState([]);
  const [holidayInput, setHolidayInput] = useState("");
  
    function defaultSchedules() {
    return daysOfWeek.map((day) => ({
      day,
      open: false,
      openingTime: "09:00",
      closingTime: "18:00"
    }));
  }


  const handleDayToggle = (day) => {
    setSchedules((prev) =>
      prev.map((s) =>
        s.day === day ? { ...s, open: !s.open } : s
      )
    );
  };

  const handleTimeChange = (day, field, value) => {
    setSchedules((prev) =>
      prev.map((s) =>
        s.day === day ? { ...s, [field]: value } : s
      )
    );
  };

  const handleAddHoliday = () => {
    if (holidayInput) {
      setHolidays([...holidays, holidayInput]);
      setHolidayInput("");
    }
  };
  

  
  const handleOpen = (warehouse?: WarehouseDTO) => {
    if (warehouse) {
      setEditingWarehouse(warehouse);
      setForm(warehouse);
      setSchedules(editingWarehouse?.schedules || defaultSchedules);
    setHolidays(editingWarehouse?.holidays || []);
    } else {
      setEditingWarehouse(null);
      setForm({
        name: "",
        address: "",
        city: "",
        state: "",
        country: "",
        postalCode: "",
        supplierId: undefined,
        phone: "",
        email:"",
        latitude: "",
        longitude:"",
            primary: 0
      });
       setSchedules(defaultSchedules);
    setHolidays([]);
    }
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
       
      if (
    !form.name ||
    !form.address ||
    !form.city ||
    !form.state ||
    !form.country ||
    !form.postalCode ||
    !form.supplierId
  ) {
    alert("Please fill in all required fields.");
    return;
  }
 const payload = {
    ...form,
    schedules: schedules,
    holidays: holidays,
  };
    
    console.log("form ", payload);
                      
    if (editingWarehouse) {
      // Update
      await warehouseService.updateWarehouse(editingWarehouse.warehouseId, payload);
    } else {
      // Create
      await warehouseService.saveWarehouse(payload);
    }
    fetchWarehouses();
    handleClose();
  };

  const handleDelete = async (id: number) => {
      
       if (window.confirm("Are you sure you want to delete this Warehouse?")) {
      try {
        await warehouseService.deleteSupplierWarehouse(id);// axiosInstance.delete(`/brands/${id}`);
       fetchWarehouses();
      } catch (err) {
        console.error("Error deleting Warehouse", err);
      }
    }
    
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">Warehouse Management</h2>

      <Button
        variant="contained"
        color="primary"
        onClick={() => handleOpen()}
        className="mb-4"
      >
        Add Warehouse
      </Button>

      <div style={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={warehouses}
          columns={[
            { field: "warehouseId", headerName: "ID", width: 70 },
            { field: "supplierName", headerName: "Supplier Name", flex: 1 },
            { field: "name", headerName: "Name", flex: 1 },
            { field: "city", headerName: "City", flex: 1 },
            { field: "country", headerName: "Country", flex: 1 },
            { field: "postalCode", headerName: "Postal Code", flex: 1 },
            { field: "phone", headerName: "Phone Number", flex: 1 },
            {
              field: "actions",
              headerName: "Actions",
              width: 200,
              renderCell: (params) => (
                <>
                  <Button
                    size="small"
                    onClick={() => handleOpen(params.row)}
                    variant="outlined"
                    color="primary"
                  >
                    Edit
                  </Button>
                  <Button
                    size="small"
                    onClick={() => handleDelete(params.row.warehouseId)}
                    variant="outlined"
                    color="secondary"
                    style={{ marginLeft: 8 }}
                  >
                    Delete
                  </Button>
                </>
              ),
            },
          ]}
          getRowId={(row) => row.warehouseId}
          pageSize={5}
        />
      </div>

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {editingWarehouse ? "Edit Warehouse" : "Add Warehouse"}
        </DialogTitle>
        <DialogContent>
       
               <InputLabel id="supplier-label">Supplier</InputLabel>
      <Select
        labelId="supplier-label"
        id="supplierId"
        // Set the value of the Select to the selected supplier's ID.
        value={form.supplierId || ''}
        onChange={handleSupplierChange}
        label="Supplier"
        required
        width="20px"
      >
        <MenuItem value="">
          <em>Select Supplier</em>
        </MenuItem>
        {suppliers.map((sup) => (
          // Use the unique ID as the value for each MenuItem.
          <MenuItem key={sup.supplierId} value={sup.supplierId}>
            {sup.supplierName}
          </MenuItem>
        ))}
      </Select>

          <TextField
            margin="dense"
            label="Name"
            name="name"
            value={form.name}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            margin="dense"
            label="Address"
            name="address"
            value={form.address}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            margin="dense"
            label="City"
            name="city"
            value={form.city}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            margin="dense"
            label="State"
            name="state"
            value={form.state}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            margin="dense"
            label="Country"
            name="country"
            value={form.country}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            margin="dense"
            label="Postal Code"
            name="postalCode"
            value={form.postalCode}
            onChange={handleChange}
            fullWidth
            required 
          />
              
          <TextField
            margin="dense"
            label="Phone Number"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            fullWidth
            required 
          />
              
          <TextField
            margin="dense"
            label="Email"
            name="email"
            value={form.email}
            onChange={handleChange}
            fullWidth
            required 
          />
              
                        <TextField
            margin="dense"
            label="Latitude"
            name="latitude"
            value={form.latitude}
            onChange={handleChange}
            fullWidth
            required 
          />
              
          <TextField
            margin="dense"
            label="Longitude"
            name="longitude"
            value={form.longitude}
            onChange={handleChange}
            fullWidth
            required 
          />
     
      {/* Primary selector (radio) */}
      <FormControl component="fieldset" sx={{ mt: 1 }}>
        <FormLabel component="legend">Primary Warehouse</FormLabel>
        <RadioGroup
          row
          name="primary"
          value={String(form.primary ?? 0)}
          onChange={(e) => setForm({ ...form, primary: Number(e.target.value) })}
        >
          <FormControlLabel value="1" control={<Radio />} label="Primary" />
          <FormControlLabel value="0" control={<Radio />} label="Secondary" />
        </RadioGroup>
      </FormControl>
 
        <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Typography variant="h6">Warehouse Availability</Typography>
      </Grid>

      {schedules.map((s) => (
        <Grid container item xs={12} key={s.day} spacing={1} alignItems="center">
          <Grid item xs={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={s.open}
                  onChange={() => handleDayToggle(s.day)}
                />
              }
              label={s.day}
            />
          </Grid>
          {s.open && (
            <>
              <Grid item xs={4}>
                <TextField
                  label="Opening Time"
                  type="time"
                  value={s.openingTime}
                  onChange={(e) =>
                    handleTimeChange(s.day, "openingTime", e.target.value)
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label="Closing Time"
                  type="time"
                  value={s.closingTime}
                  onChange={(e) =>
                    handleTimeChange(s.day, "closingTime", e.target.value)
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </>
          )}
        </Grid>
      ))}

      {/* Holidays */}
      <Grid item xs={12}>
        <Typography>Holidays</Typography>
        <TextField
          type="date"
          value={holidayInput}
          onChange={(e) => setHolidayInput(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Button onClick={handleAddHoliday}>Add Holiday</Button>
        <ul>
          {holidays.map((h, i) => (
            <li key={i}>{h}</li>
          ))}
        </ul>
      </Grid>
</Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default WarehouseManager;
